import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  ButtonProps,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

export type SimpleDialogProps = {
  onClose: () => void;
  onConfirm?: () => void;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  title: string;
  message?: string;
  confirmProps?: Omit<ButtonProps, "onClick">;
  dismissProps?: Omit<ButtonProps, "onClick">;
  children?: React.ReactNode;
  loading?: boolean;
  responsiveFullScreen?: boolean;
};

const SimpleDialog: React.FC<SimpleDialogProps> = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    onClose,
    onConfirm,
    onSubmit,
    title,
    message,
    confirmProps = {},
    dismissProps = {},
    children,
    loading = false,
    responsiveFullScreen = false,
  } = props;

  Object.assign(confirmProps, {
    children: "Bekräfta",
    startIcon: <CheckIcon />,
    type: "submit",
    variant: "contained",
    ...props.confirmProps,
  });

  Object.assign(dismissProps, {
    children: "Avbryt",
    startIcon: <CloseIcon />,
    variant: "outlined",
    ...props.dismissProps,
  });

  return (
    <Dialog
      open={true}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
      fullWidth
      maxWidth="xs"
      fullScreen={responsiveFullScreen ? isSmallScreen : false}
      {...(onSubmit && {
        component: "form",
        onSubmit: onSubmit as React.FormEventHandler<HTMLElement>,
      })}
    >
      <DialogTitle>{title}</DialogTitle>

      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 12, color: "grey.500" }}
      >
        <CloseIcon />
      </IconButton>

      {(message || children) && (
        <DialogContent>
          {message && <DialogContentText>{message}</DialogContentText>}
          {children}
        </DialogContent>
      )}

      <DialogActions>
        <Button onClick={onClose} {...dismissProps} disabled={dismissProps.disabled || loading} />

        <Button onClick={onConfirm} {...confirmProps} loading={confirmProps.loading || loading} />
      </DialogActions>
    </Dialog>
  );
};

export default SimpleDialog;
